import { useState } from "react";

export default function LoginPage({ login, error }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const submit = (event) => {
    event.preventDefault();
    login(username, password);
  };

  return (
    <div className="login-page">
      <div className="login-panel">
        <div className="login-brand">
          <span>FinFlow</span>
          <h1>Вход в систему</h1>
          <p>Введите username и password, которые создал администратор.</p>
        </div>

        <form className="login-form" onSubmit={submit}>
          <label>
            Username
            <input
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              placeholder="admin"
              autoComplete="username"
            />
          </label>

          <label>
            Password
            <input
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Введите пароль"
              type="password"
              autoComplete="current-password"
            />
          </label>

          {error && <div className="login-error">{error}</div>}

          <button type="submit">Войти</button>
        </form>
      </div>
    </div>
  );
}
